import { CornSchema } from '@eigtech/shared-corn';
import { z } from 'zod';
import { BillSchema } from '../base/bill.js';
export const GatherBillAdditionalParamsRequestSchema = z.object({
    bill: BillSchema.pick({ total: true, vendor: true }),
    entityId: CornSchema,
});
export const GatherBillAdditionalParamsResponseSchema = z.object({
    additional: z.record(z.string(), z.unknown()).optional(),
});
